<template>
  <div class="inventoryHistories">
    <div style="margin-bottom: 10px;">
      <el-text style="font-size: larger; font-weight: bolder;">{{ util.language('库存记录', 'Inventory history') }}</el-text>
    </div>
    <el-form :inline="true">
      <el-form-item :label="util.language('操作时间', 'Operation time')">
        <el-date-picker style="width: 220px;" v-model="searchParam.createDatetimes" type="daterange" range-separator="~" />
      </el-form-item>
      <el-form-item :label="util.language('商品编码', 'Product code')">
        <el-input style="width: 150px;" v-model="searchParam.productCode" clearable />
      </el-form-item>
      <el-form-item :label="util.language('操作', 'Operation')">
        <el-select filterable clearable v-model="searchParam.operate" style="width: 120px;">
          <el-option :label="util.language('后台设置', 'Backend')" value="BACKEND" />
          <el-option :label="util.language('订单', 'Order')" value="ORDER" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()" :loading="loading.find">{{ util.language('搜索', 'Search') }}</el-button>
          <el-button @click="resetSearchParam()">{{ util.language('重置', 'Reset') }}</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="data.inventoryHistoryList" ref="tabRef" border style="height: calc(100vh - 220px);" v-loading="loading.find">
      <el-table-column prop="operate" :label="util.language('操作', 'Operation')" width="100" show-overflow-tooltip>
        <template #default="scope">
          <el-text v-if="scope.row.operate == 'BACKEND'">{{ util.language('后台设置', 'Backend') }}</el-text>
          <el-text v-if="scope.row.operate == 'ORDER'">{{ util.language('订单', 'Order') }}</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="productCode" :label="util.language('商品编码', 'Product code')" width="150" show-overflow-tooltip />
      <el-table-column prop="unitPriceIn" :label="util.language('进价', 'Purchase price')" align="right" width="130" show-overflow-tooltip />
      <el-table-column prop="unitQuantity" :label="util.language('单位数量', 'Sum unit QTY')" align="right" width="130" show-overflow-tooltip />
      <el-table-column prop="fromQuantity" :label="util.language('修改前数量', 'From QTY')" align="right" width="100" show-overflow-tooltip />
      <el-table-column prop="toQuantity" :label="util.language('修改后数量', 'To QTY')" align="right" width="100" show-overflow-tooltip />
      <el-table-column prop="quantity" :label="util.language('数量', 'QTY')" align="right" width="100" show-overflow-tooltip>
        <template #default="scope">
          <el-text>{{ math.plus(scope.row.toQuantity, -scope.row.fromQuantity) }}</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="note" :label="util.language('备注', 'Note')" min-width="100" show-overflow-tooltip />
      <el-table-column :label="util.language('操作时间', 'Operation time')" width="160" show-overflow-tooltip>
        <template #default="scope">
          <el-text>{{ util.parseTime(scope.row.createDatetime) }}</el-text>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 10px;" />
    <el-pagination v-model:current-page="searchParam.pageNum" v-model:page-size="searchParam.pageSize" :page-sizes="[50, 100, 200]" background layout="total, sizes, prev, pager, next, jumper" :total="data.inventoryHistoryTotal"
      @change="commitFindList()" />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const shopId = cache.getString(cache.keys.shopId) * 1
if (!shopId) {
  ElMessage.error(util.language('请先选择店铺', 'Please select a shop first'))
}
const router = useRouter()
const tabRef = ref()

const pageParam = cache.getObject(cache.keys.pageParam + "inventoryHistories")

const data = reactive({
  inventoryHistoryList: [],
  inventoryHistoryTotal: 0
})
const loading = reactive({
  find: false
})
const show = reactive({
})

const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.pageNum = 1
  searchParam.pageSize = 50
  searchParam.shopId = shopId || 0
  searchParam.productCode = pageParam?.productCode || ''
  searchParam.createDatetimes = []
  searchParam.operate = pageParam?.operate || null
}
resetSearchParam()

const commitFindList = () => {
  loading.find = true
  const params = JSON.parse(JSON.stringify(searchParam))
  if (params.createDatetimes && params.createDatetimes.length == 2) {
    params.createDatetimeGe = new Date(params.createDatetimes[0]).getTime()
    params.createDatetimeLt = new Date(params.createDatetimes[1]).getTime() + 24 * 60 * 60 * 1000
  }
  params.createDatetimes = null
  api.get('/backend/product/getInventoryHistoryPage', { params: params }).then(res => {
    data.inventoryHistoryList = res.list
    data.inventoryHistoryTotal = res.total
  }).finally(() => {
    loading.find = false
  })
}
commitFindList()

</script>

<style lang="less"></style>